<div *ngFor="let code of errorCodes">
  <ng-container [ngSwitch]="code">
    <div *ngSwitchCase="errorCodeEnum.LOAD_IS_AP2_MODE_ERROR">
      <span i18n>Sie haben keine Berechtigung diese Antragsart zu nutzen.</span>
    </div>

    <div *ngSwitchCase="errorCodeEnum.LOAD_DEVICES_ERROR">
      <span i18n>Komponente zur Biometrieerfassung wurde nicht gefunden oder ist nicht gestartet. Bitte starten sie Windows neu. Sollte das Problem weiter bestehen, bitte wenden Sie sich an den Administrator.</span>
    </div>

    <div *ngSwitchCase="errorCodeEnum.LOAD_VALIDATION_METADATA_ERROR">
      <span i18n>Es ist ein technischer Fehler beim Laden der Validierungen aufgetreten, bitte wenden Sie sich an den Administrator.</span>
    </div>

    <div *ngSwitchCase="errorCodeEnum.LOAD_VALUELISTS_ERROR">
      <span i18n>Es ist ein technischer Fehler beim Laden der Wertelisten aufgetreten, bitte wenden Sie sich an den Administrator.</span>
    </div>
  </ng-container>
</div>
